import { dm_suckhoe, IDmSucKhoe } from "../../../models/response/category/dm_suckhoe";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";
export const objSucKhoeDefine = {
    LOAD_START: "",
    LOAD_SUCCESS: [] as IDmSucKhoe[],
    LOAD_ERROR: "",
    SHOW_EDIT_MODAL: {} as dm_suckhoe | undefined,
    CLOSE_EDIT_MODAL: undefined,
    SAVE_START: {} as dm_suckhoe,
    SAVE_SUCESS: {} as dm_suckhoe,
    SAVE_ERROR: "",
    DELETE_START: 0,
    DELETE_SUCESS: undefined,
    DELETE_ERROR: ""
};

export const eSucKhoeActionTypeIds = generateActionTypeIds(objSucKhoeDefine, "SUC_KHOE")
export type ISucKhoeActionTypes = IGenericActionType<typeof objSucKhoeDefine, "SUC_KHOE">
